/*global define*/
define(function ( ) {

    'use strict';

    var prefix = "";

    return {

        MISSING_CONTAINER : prefix + "missing_container",
        MISSING_BUTTONS : prefix + "missing_button",

    };
});


//////////////////
// WEBPACK FOOTER
// ./src/config/errors.js
// module id = 31
// module chunks = 0